// W-0657 — Lista de E-mail de Clientes (GES > Ferramentas)
// Endpoints dedicados para preservar paridade 1:1 com Delphi
// (lookups globais /ramo/listar, /opcao/regioes, /cidades divergem por filtros/paginacao/RBAC)
import { httpService } from '~/Services/Service';

export const gerarListaEmailClientes = (params) =>
  httpService.get('/ferramentas/lista-email/emails', { params });

export const listarVendedoresEmail = () =>
  httpService.get('/ferramentas/lista-email/vendedores');

// Fonte Delphi: UDMFerramentas.dfm — Tramo (Select * From Ramo)
export const listarRamosEmail = () =>
  httpService.get('/ferramentas/lista-email/ramos');

// Fonte Delphi: UDMFerramentas.dfm — TRegiao (Select * From Tab_Regiao)
export const listarRegioesEmail = () =>
  httpService.get('/ferramentas/lista-email/regioes');

// Fonte Delphi: UDMFerramentas.dfm — Tcidade (Select * From Tab_Cidades Order by Descricao_Cidade)
// W-0657 BUG-4: cascade Região→Cidade (melhoria) — codigoRegiao opcional filtra as cidades da região.
export const listarCidadesEmail = (codigoRegiao = null) =>
  httpService.get('/ferramentas/lista-email/cidades', {
    params: codigoRegiao != null ? { codigoRegiao } : {},
  });
